import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import Shell from "@/components/Shell.vue";
import Login from "@/views/Login/Login.vue";
import Dashboard from "@/views/Dashboard/Dashboard.vue";
import Artikli from "@/views/Sifarnici/Artikli/Artikli.vue";
import TrgovinskiLanci from "@/views/Sifarnici/TrgovinskiLanci/TrgovinskiLanci.vue";
import Stalci from "@/views/Sifarnici/Stalci/Stalci.vue";
import Objekti from "@/views/Objekti/Objekti.vue";
import Posete from "@/views/Posete/Posete.vue";
import PonovnePosete from "@/views/Posete/PonovnePosete.vue";
import PlaniranePosete from "@/views/Posete/PlaniranePosete.vue";
import Komentari from "@/views/Posete/Komentari.vue";
import Poseta from "@/views/Posete/Poseta.vue";
import IzvestajAktivnosti from "@/views/Izvestaji/IzvestajAktivnosti/IzvestajAktivnosti.vue";
import PrometPoDistributerima from "@/views/Izvestaji/Prometi/PrometPoDistributerima.vue";
import PrometIPoslednjaPoseta from "@/views/Izvestaji/Prometi/PrometIPoslednjaPoseta.vue";
import Korisnici from "@/views/Korisnici/Korisnici.vue";
import DnevnaAktivnostMerchandisera from "@/views/Izvestaji/Merchandisers/DnevnaAktivnostMerchandisera/DnevnaAktivnostMerchandisera.vue";
import MesecniMerchandisingIzvestaj from "@/views/Izvestaji/Merchandisers/MesecniMerchandisingIzvestaj/MesecniMerchandisingIzvestaj.vue";
//import SlikePoseta from "@/views/Izvestaji/Merchandisers/SlikePoseta/SlikePoseta.vue";
import AbcAnalizaKupaca from "@/views/Izvestaji/AbcAnalizaKupaca/AbcAnalizaKupaca.vue";
import Zalihe from "@/views/Izvestaji/Zalihe/Zalihe2.vue";
import Narudzbenice from "@/views/Dokumenta/Narudzbenice.vue";
import { store } from "./store";
import PregledDokumenta from "@/views/Dokumenta/PregledDokumenta.vue";
import TipoviObjekata from "@/views/Sifarnici/TipoviObjekata/TipoviObjekata.vue";
import KategorijeObjekata from "@/views/Sifarnici/KategorijeObjekata/KategorijeObjekata.vue";
import Distributeri from "@/views/Sifarnici/Distributeri/Distributeri.vue";
import Aktivnosti from "@/views/Sifarnici/Aktivnosti/Aktivnosti.vue";
import MinMaxStock from "@/views/Izvestaji/Zalihe/MinMaxStock.vue";

Vue.use(VueRouter);

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes: [
        { path: "/", redirect: "dashboard" },
        {
            path: "/",
            component: Shell,
            children: [
                {
                    path: "/dashboard",
                    name: "dashboard",
                    component: Dashboard,
                    meta: { protected: true },
                },
                {
                    path: "/artikli",
                    name: "artikli",
                    component: Artikli,
                    meta: { protected: true },
                },
                {
                    path: "/trgovinski-lanci",
                    name: "trgovinskiLanci",
                    component: TrgovinskiLanci,
                    meta: { protected: true },
                },
                {
                    path: "/stalci",
                    name: "stalci",
                    component: Stalci,
                    meta: { protected: true },
                },
                {
                    path: "/objekti/:storePublicID?",
                    name: "objekti",
                    component: Objekti,
                    meta: { protected: true },
                },
                {
                    path: "/posete",
                    name: "posete",
                    component: Posete,
                    meta: { protected: true },
                },
                {
                    path: "/ponovnePosete",
                    name: "ponovnePosete",
                    component: PonovnePosete,
                    meta: { protected: true },
                },
                {
                    path: "/planiranePosete",
                    name: "planiranePosete",
                    component: PlaniranePosete,
                    meta: { protected: true },
                },
                {
                    path: "/komentari",
                    name: "komentari",
                    component: Komentari,
                    meta: { protected: true },
                },
                {
                    path: "/poseta/:publicVisitID",
                    name: "poseta",
                    component: Poseta,
                    meta: { protected: true },
                },
                {
                    path: "/izvestaji/izvestaj-aktivnosti",
                    name: "izvestajAktivnosti",
                    component: IzvestajAktivnosti,
                    meta: { protected: true },
                },
                {
                    path: "/promet-po-distributerima",
                    name: "prometPoDistributerima",
                    component: PrometPoDistributerima,
                    meta: { protected: true },
                },
                {
                    path: "/promet-poslednja-poseta",
                    name: "prometIPoslednjaPoseta",
                    component: PrometIPoslednjaPoseta,
                    meta: { protected: true },
                },
                {
                    path: "/korisnici",
                    name: "administracijaKorisnika",
                    component: Korisnici,
                    meta: { protected: true },
                },
                {
                    path: "/dnevna-aktivnost-merchandisera",
                    name: "dnevnaAktivnostMerchandisera",
                    component: DnevnaAktivnostMerchandisera,
                    meta: { protected: true },
                },
                {
                    path: "/mesecni-merchandising-izvestaj",
                    name: "mesecniMerchandisingIzvestaj",
                    component: MesecniMerchandisingIzvestaj,
                    meta: { protected: true },
                },
                /*{
                    path: "/merchandisers-slike-poseta",
                    name: "merchandisersSlikePoseta",
                    component: SlikePoseta,
                    meta: { protected: true },
                },*/
                {
                    path: "/izvestaji-abc-analiza-kupaca",
                    name: "abcAnalizaKupaca",
                    component: AbcAnalizaKupaca,
                    meta: { protected: true },
                },
                {
                    path: "/izvestaji-zalihe",
                    name: "zalihe",
                    component: Zalihe,
                    meta: { protected: true },
                },
                {
                    path: "/narudzbenice",
                    name: "narudzbenice",
                    component: Narudzbenice,
                    meta: { protected: true },
                },
                {
                    path: "/dokumenti/narudzbenice/:id",
                    name: "pregled dokumenta",
                    component: PregledDokumenta,
                    meta: { protected: true },
                },
                {
                    path: "/tipovi-objekata",
                    name: "tipoviObjekata",
                    component: TipoviObjekata,
                    meta: { protected: true },
                },
                {
                    path: "/kategorije-objekata",
                    name: "kategorijeObjekata",
                    component: KategorijeObjekata,
                    meta: { protected: true },
                },
                {
                    path: "/distributeri",
                    name: "distributeri",
                    component: Distributeri,
                    meta: { protected: true },
                },
                {
                    path: "/aktivnosti",
                    name: "aktivnosti",
                    component: Aktivnosti,
                    meta: { protected: true },
                },
                {
                    path: "/min-max-stock",
                    name: "minimalneZalihe",
                    component: MinMaxStock,
                    meta: { protected: true },
                },
            ],
        },

        { path: "/login", name: "login", component: Login },
        { path: "*", redirect: "dashboard" },
    ],
});

router.beforeEach((to, from, next) => {
    if (!to.meta.protected) {
        return next();
    }
    if (store.getters.isAuthenticated) {
        next();
    } else {
        console.warn("Redirecting to Login page from router beforeEach");
        next("/login");
    }
});

/*axios.interceptors.response.use(
    (resp) => resp,
    (err) => {
        if (err.response && err.response.status === 401) {
            console.warn("Axios interceptor reported 401");
            //return router.push("/login");
        }
        throw err;
    }
);*/

export default router;
